import React from 'react';
import { Document, Page, Text, View, Image, StyleSheet } from '@react-pdf/renderer';

// Note: Removed external font registration (GreatVibes) as it causes PDF generation failures
// Using italic style for signatures instead

// Base64 encoded logo for PDF rendering
const logoBase64 = 'data:image/png;base64,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';

export type ContractData = {
  title: string;
  contractName: string;
  pdl: string; // Service Address
  pricePerKwh: string;
  date?: string;
  contractNumber?: string;
  clientNumber?: string; // User's client number (e.g., CLI00000020)
  customerName?: string;
  meterNumber?: string;
  apartmentNumber?: string;
  buildingName?: string;
  organizationName?: string;
  signatureName?: string;
  signedAt?: string;
  logoUrl?: string; // Organization logo URL
  currency?: string; // Currency for display (e.g., "TSh", "GHS")
};

export type ContractPDFProps = {
  data: ContractData;
  qrDataUrl?: string;
  barcodeDataUrl?: string;
};

const colors = {
  primary: '#2563EB',      // Blue
  primaryDark: '#1D4ED8',  // Darker blue
  secondary: '#1E40AF',
  text: '#1F2937',
  muted: '#6B7280',
  light: '#9CA3AF',
  divider: '#E5E7EB',
  surface: '#FFFFFF',
};

const styles = StyleSheet.create({
  page: {
    padding: 24,
    backgroundColor: colors.surface,
    color: colors.text,
    fontSize: 10,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 14,
    paddingBottom: 12,
    borderBottomWidth: 2,
    borderBottomColor: colors.primary,
  },
  logo: {
    width: 260,
    height: 90,
    objectFit: 'contain',
  },
  headerRight: {
    alignItems: 'flex-end',
  },
  contractTitle: {
    fontSize: 16,
    fontWeight: 'bold',
    color: colors.primary,
    marginBottom: 4,
  },
  contractSubtitle: {
    fontSize: 9,
    color: colors.muted,
  },
  contractNumber: {
    fontSize: 9,
    fontWeight: 'bold',
    color: colors.text,
    marginTop: 4,
  },
  twoColumn: {
    flexDirection: 'row',
    marginBottom: 12,
  },
  columnLeft: {
    width: '50%',
    paddingRight: 12,
  },
  columnRight: {
    width: '50%',
    paddingLeft: 12,
  },
  sectionTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: colors.primary,
    marginBottom: 6,
    paddingBottom: 4,
    borderBottomWidth: 1,
    borderBottomColor: colors.divider,
    textTransform: 'uppercase',
  },
  infoRow: {
    flexDirection: 'row',
    marginBottom: 5,
  },
  infoLabel: {
    width: '45%',
    fontSize: 9,
    color: colors.muted,
  },
  infoValue: {
    width: '55%',
    fontSize: 9,
    fontWeight: 'bold',
    color: colors.text,
  },
  boxSection: {
    backgroundColor: '#F9FAFB',
    padding: 12,
    borderRadius: 4,
    marginBottom: 12,
    borderWidth: 1,
    borderColor: colors.divider,
  },
  boxTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    color: colors.primaryDark,
    marginBottom: 6,
  },
  termsSection: {
    marginBottom: 10,
  },
  termsTitle: {
    fontSize: 10,
    fontWeight: 'bold',
    color: colors.text,
    marginBottom: 5,
  },
  termsText: {
    fontSize: 8,
    color: colors.muted,
    lineHeight: 1.4,
  },
  signatureSection: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: colors.divider,
  },
  signatureBox: {
    width: '45%',
  },
  signatureTitle: {
    fontSize: 9,
    fontWeight: 'bold',
    color: colors.text,
    marginBottom: 6,
  },
  signatureLine: {
    borderBottomWidth: 1,
    borderBottomColor: colors.text,
    height: 28,
    marginBottom: 4,
  },
  signatureLabel: {
    fontSize: 8,
    color: colors.muted,
  },
  digitalSignature: {
    fontFamily: 'Times-Italic',
    fontSize: 16,
    color: colors.secondary,
    marginBottom: 4,
    paddingBottom: 4,
    borderBottomWidth: 1,
    borderBottomColor: colors.secondary,
  },
  signedBadge: {
    backgroundColor: '#DBEAFE',  // Light blue
    padding: 4,
    borderRadius: 3,
    marginTop: 4,
    alignSelf: 'flex-start',
  },
  signedBadgeText: {
    fontSize: 9,
    color: colors.primaryDark,
    fontWeight: 'bold',
  },
  qrBox: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  qr: {
    width: 65,
    height: 65,
  },
  qrLabel: {
    fontSize: 7,
    color: colors.muted,
    marginTop: 4,
  },
  footer: {
    position: 'absolute',
    bottom: 16,
    left: 24,
    right: 24,
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: colors.divider,
  },
  footerLeft: {
    width: '70%',
  },
  footerRight: {
    width: '30%',
    alignItems: 'flex-end',
  },
  footerText: {
    fontSize: 8,
    color: colors.light,
    marginBottom: 3,
  },
  footerBold: {
    fontSize: 8,
    fontWeight: 'bold',
    color: colors.muted,
  },
  highlight: {
    backgroundColor: '#DBEAFE',  // Light blue
    padding: 12,
    borderRadius: 4,
    marginBottom: 16,
  },
  highlightText: {
    fontSize: 10,
    color: colors.primaryDark,
    textAlign: 'center',
  },
});

const ContractPDF: React.FC<ContractPDFProps> = ({ data, qrDataUrl }) => {
  const currentDate = data.date || new Date().toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const generatedDate = new Date().toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const contractRef = data.contractNumber || `GE-${Date.now().toString().slice(-8)}`;

  return (
    <Document>
      <Page size="A4" orientation="portrait" style={styles.page}>
        {/* Header */}
        <View style={styles.header}>
          <View>
            <Image src={data.logoUrl || logoBase64} style={styles.logo} />
            {!data.logoUrl && (
              <Text style={{ fontSize: 7, color: colors.muted, marginTop: 3 }}>
                Member of Solio Group
              </Text>
            )}
          </View>
          <View style={styles.headerRight}>
            <Text style={styles.contractTitle}>SMART METER AGREEMENT</Text>
            <Text style={styles.contractSubtitle}>Prepaid Electricity Supply Contract</Text>
            <Text style={styles.contractNumber}>Ref: {contractRef}</Text>
          </View>
        </View>

        {/* Highlight Box */}
        <View style={styles.highlight}>
          <Text style={styles.highlightText}>
            This contract certifies the energy supply agreement between {data.organizationName || 'the Provider'} and the customer named below.
          </Text>
        </View>

        {/* Two Column Layout - Customer & Contract Info */}
        <View style={styles.twoColumn}>
          <View style={styles.columnLeft}>
            <Text style={styles.sectionTitle}>Customer Information</Text>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Full Name:</Text>
              <Text style={styles.infoValue}>{data.customerName || 'N/A'}</Text>
            </View>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Customer ID:</Text>
              <Text style={styles.infoValue}>{data.clientNumber || 'N/A'}</Text>
            </View>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Building:</Text>
              <Text style={styles.infoValue}>{data.buildingName || 'N/A'}</Text>
            </View>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Apartment:</Text>
              <Text style={styles.infoValue}>{data.apartmentNumber || 'N/A'}</Text>
            </View>
          </View>

          <View style={styles.columnRight}>
            <Text style={styles.sectionTitle}>Contract Details</Text>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Effective Date:</Text>
              <Text style={styles.infoValue}>{currentDate}</Text>
            </View>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Meter Number:</Text>
              <Text style={styles.infoValue}>{data.meterNumber || 'Pending'}</Text>
            </View>
            <View style={styles.infoRow}>
              <Text style={styles.infoLabel}>Organization:</Text>
              <Text style={styles.infoValue}>{data.organizationName || 'Growth Energy'}</Text>
            </View>
          </View>
        </View>

        {/* Tariff Information */}
        <View style={styles.boxSection}>
          <Text style={styles.boxTitle}>Tariff & Pricing</Text>
          <View style={styles.twoColumn}>
            <View style={styles.columnLeft}>
              <View style={styles.infoRow}>
                <Text style={styles.infoLabel}>Energy Rate:</Text>
                <Text style={styles.infoValue}>{data.pricePerKwh} per kWh</Text>
              </View>
              <View style={styles.infoRow}>
                <Text style={styles.infoLabel}>Billing Type:</Text>
                <Text style={styles.infoValue}>Prepaid (Pay-as-you-go)</Text>
              </View>
            </View>
            <View style={styles.columnRight}>
              <View style={styles.infoRow}>
                <Text style={styles.infoLabel}>Currency:</Text>
                <Text style={styles.infoValue}>{data.currency || 'TZS (Tanzanian Shilling)'}</Text>
              </View>
              <View style={styles.infoRow}>
                <Text style={styles.infoLabel}>Payment:</Text>
                <Text style={styles.infoValue}>ClickPesa / Credit Card</Text>
              </View>
            </View>
          </View>
        </View>

        {/* Agreement Overview */}
        <View style={styles.termsSection}>
          <Text style={styles.termsTitle}>Agreement Overview</Text>
          <Text style={styles.termsText}>
            This contract outlines the terms and conditions for the use of the prepaid smart meter installed at the above-mentioned property.
          </Text>
        </View>

        {/* Prepaid Meter Terms */}
        <View style={styles.termsSection}>
          <Text style={styles.termsTitle}>Prepaid Meter Terms</Text>
          <Text style={styles.termsText}>
            • The smart meter is a prepaid device, and electricity consumption must be funded in advance.{'\n'}
            • The rate of electricity is billed at {data.pricePerKwh} per kWh. This rate is subject to change, and the tenant will be informed prior to any increase.
          </Text>
        </View>

        {/* Payment Methods */}
        <View style={styles.termsSection}>
          <Text style={styles.termsTitle}>Payment Methods</Text>
          <Text style={styles.termsText}>
            • Payments can be made exclusively through ClickPesa or credit card.{'\n'}
            • Cash payments are not accepted.
          </Text>
        </View>

        {/* Tampering Policy */}
        <View style={styles.termsSection}>
          <Text style={styles.termsTitle}>Tampering Policy</Text>
          <Text style={styles.termsText}>
            • The smart meter must not be tampered with.{'\n'}
            • Any tampering will trigger an automatic alert to the management, resulting in a fine and being billed for any damages or losses incurred.
          </Text>
        </View>

        {/* Acknowledgment */}
        <View style={styles.termsSection}>
          <Text style={styles.termsTitle}>Acknowledgment</Text>
          <Text style={styles.termsText}>
            By signing below, I acknowledge that I have read and understood the terms of this Smart Meter Agreement.
          </Text>
        </View>

        {/* Signature Section with QR */}
        <View style={styles.signatureSection}>
          <View style={styles.signatureBox}>
            <Text style={styles.signatureTitle}>Customer Signature</Text>
            {data.signatureName ? (
              <>
                <Text style={styles.digitalSignature}>{data.signatureName}</Text>
                <View style={styles.signedBadge}>
                  <Text style={styles.signedBadgeText}>DIGITALLY SIGNED</Text>
                </View>
                <Text style={styles.signatureLabel}>Name: {data.customerName || data.signatureName}</Text>
                <Text style={styles.signatureLabel}>
                  Signed: {data.signedAt ? new Date(data.signedAt).toLocaleString() : currentDate}
                </Text>
              </>
            ) : (
              <>
                <View style={styles.signatureLine} />
                <Text style={styles.signatureLabel}>Name: {data.customerName || '________________________'}</Text>
                <Text style={styles.signatureLabel}>Date: {currentDate}</Text>
              </>
            )}
          </View>

          {qrDataUrl && (
            <View style={styles.qrBox}>
              <Image src={qrDataUrl} style={styles.qr} />
              <Text style={styles.qrLabel}>Scan to verify</Text>
            </View>
          )}
        </View>

        {/* Footer */}
        <View style={styles.footer}>
          <View style={styles.footerLeft}>
            <Text style={styles.footerBold}>{data.organizationName || 'Energy Provider'}</Text>
            <Text style={styles.footerText}>Smart Meter Agreement - Prepaid Electricity Service</Text>
            <Text style={styles.footerText}>Document generated on {generatedDate}</Text>
          </View>
          <View style={styles.footerRight}>
            <Text style={styles.footerText}>Ref: {contractRef}</Text>
            <Text style={styles.footerBold}>Page 1 of 1</Text>
            <Text style={{ fontSize: 5, color: '#9CA3AF', marginTop: 4 }}>Platform: Growth Energy</Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default ContractPDF;
